// JSON-LD structured data for WiseSage.AI
document.addEventListener('DOMContentLoaded', function () {
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.text = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "WiseSage.AI",
    "url": "https://wisesage.ai/",
    "description": "AI Agent Training Academy & Innovation Lab offering gamified prompts like TurnQuest, MemoryCore, Social Contract, Private AEye.",
    "sameAs": []
  });
  document.head.appendChild(script);
});
